import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "workspace-icon-gradient-white",
  "use": "workspace-icon-gradient-white-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"workspace-icon-gradient-white\"><rect opacity=\".6\" x=\"8.538\" y=\"2\" width=\"6.462\" height=\"12\" rx=\"1.284\" /><rect opacity=\".7\" x=\"1\" y=\"2\" width=\"6.462\" height=\"4\" rx=\"1.284\" /><rect x=\"1\" y=\"6.999\" width=\"6.462\" height=\"7\" rx=\"1.284\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol